import React from "react";

interface BadgeButtonProps {
  value: {
    text: string;
    color?: string;
    bgColor?: string;
    displayText?: string;
    showInfoIcon?: boolean;
    hoverText?: string;
    isDisabled?: boolean;
  };
  onReviewClick?: () => void;
  [key: string]: any;
}

export const BadgeButton: React.FC<BadgeButtonProps> = ({
  value,
  onReviewClick,
}) => {
  const handleReviewClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event?.preventDefault();
    if (value.isDisabled) {
      event.stopPropagation();
      return;
    }
    if (onReviewClick) {
      onReviewClick();
    }
  };

  const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
    if (value.isDisabled) {
      event.stopPropagation();
    }
  };

  const showOpacity =
    value.isDisabled ||
    value.text === "Not Started" ||
    value.text === "Not Sent";

  return (
    <div
      className={`table-cell-badge ${showOpacity ? "opacity-50" : ""}`}
      style={{
        color: value.color || "#000000",
        backgroundColor: value.bgColor || "#F5F5F5",
        cursor: value.isDisabled ? "default" : undefined,
      }}
      title={
        !value.showInfoIcon
          ? value.hoverText || value.displayText
          : value.displayText
      }
      onClick={handleReviewClick}
      onMouseDown={handleMouseDown}
    >
      {value.text}
    </div>
  );
};

export default BadgeButton;
